export default __webpack_public_path__ + "static/media/single_blog_image.1fe28b39.png";